<template>
    <div :class="is_mobile_app ? 'wrapper': 'wrapper'">
   <section class="row back_white mb-3" :class="isRTL ? 'rtl' : ''">
       <div class="col-12 d-flex justify-content-center">
          <h3 class="static_title">Faq<span class="small_s">s</span></h3>
      </div>

<!--Accordian Start-->
 <div class="accordion col-12" role="tablist">
    
      <div header-tag="header" class="p-1" role="tab">
        <b-button block v-b-toggle.accordion-1 variant="info" 
        class="d-flex text-capitalize btn_acc justify-content-between align-items-center mb-2">
        {{$t("REGISTRATION")}} 
        <img src="@/assets/img/icons/chevron-left.svg" class="acc_img"/> 
        </b-button>
       
      </div>
      <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel" class="mt-3">
        <div class="col-12 mb-3">
          <b-button block v-b-toggle.accordion-9 variant="info"
          class="d-flex text-capitalize btn_acc_new justify-content-between align-items-center">
          {{$t("H0W_DO_I_REGISTER_WITH_WANASATIME")}} ?
          <img src="@/assets/img/icons/down-arrow.svg" class="acc_img_new"/>
          </b-button>
        <b-collapse id="accordion-9" visible accordion="my-accordion-new" role="tabpanel">
                <div class="mt-2">
                <p :class="isRTL ? 'text-right' : ''">{{$t("CLICK_ON_SIGN_UP")}}.{{$t("ENTER_FULL_NAME")}}. 
                    {{$t("ONCE_YOU_COMPLETE")}}.</p>
                </div>
        </b-collapse>
        
        </div>

          <div class="col-12 mb-3">
          <b-button block v-b-toggle.accordion-10 variant="info"
          class="d-flex text-capitalize btn_acc_new justify-content-between align-items-center">
           {{$t("IT_IS_NECESSARY")}} ?
          <img src="@/assets/img/icons/down-arrow.svg" class="acc_img_new"/>
          </b-button>
        <b-collapse id="accordion-10" visible accordion="my-accordion-new" role="tabpanel">
                <div class="mt-2">
                <p :class="isRTL ? 'text-right' : ''">{{$t("NO_IT_IS_NOT_NECESSARY")}}</p>
                </div>
        </b-collapse>
        
        </div>


          <div class="col-12 mb-3">
          <b-button block v-b-toggle.accordion-11 variant="info"
          class="d-flex text-capitalize btn_acc_new justify-content-between align-items-center">
          {{$t("WHY_AM_I")}} ?
          <img src="@/assets/img/icons/down-arrow.svg" class="acc_img_new"/>
          </b-button>
        <b-collapse id="accordion-11" visible accordion="my-accordion-new" role="tabpanel">
                <div class="mt-2">
                <p :class="isRTL ? 'text-right' : ''">{{$t("WE_REQUEST")}} 
                    <br>{{$t("TO_ENSURE")}}.<br>{{$t("TO_NOTIFY")}}. 
                    <br>{{$t("TO_SEND")}}.</p>
                </div>
        </b-collapse>
        
        </div>


           <div class="col-12 mb-3">
          <b-button block v-b-toggle.accordion-12 variant="info"
          class="d-flex text-capitalize btn_acc_new justify-content-between align-items-center">
          {{$t("WHAT_ARE_THE_BENEFITS")}} ?
          <img src="@/assets/img/icons/down-arrow.svg" class="acc_img_new"/>
          </b-button>
        <b-collapse id="accordion-12" visible accordion="my-accordion-new" role="tabpanel">
                <div class="mt-2">
                <p :class="isRTL ? 'text-right' : ''">{{$t("USER_CAN_OPT")}}</p>
                </div>
        </b-collapse>
        
        </div>


           <div class="col-12 mb-3">
          <b-button block v-b-toggle.accordion-13 variant="info"
          class="d-flex text-capitalize btn_acc_new justify-content-between align-items-center">
          {{$t("HOW_DO_I")}}
          <img src="@/assets/img/icons/down-arrow.svg" class="acc_img_new"/>
          </b-button>
        <b-collapse id="accordion-13" visible accordion="my-accordion-new" role="tabpanel">
                <div class="mt-2">
                <p :class="isRTL ? 'text-right' : ''">{{$t("USER_CAN_RETRIEVE")}}</p>
                </div>
        </b-collapse>
        
        </div>
</b-collapse>


      <div header-tag="header" class="p-1" role="tab">
        <b-button block v-b-toggle.accordion-2 variant="info" class="d-flex text-capitalize btn_acc justify-content-between align-items-center mb-2">
        {{$t("TICKET_BOOKING")}} <img src="@/assets/img/icons/chevron-left.svg" class="acc_img"/> </b-button>
      
      </div>
      <b-collapse id="accordion-2" visible accordion="my-accordion" role="tabpanel" class="mt-3">

        <div class="col-12 mb-3">
          <b-button block v-b-toggle.accordion-14 variant="info"
          class="d-flex text-capitalize btn_acc_new justify-content-between align-items-center">
          {{$t("HOW_DO_I_KNOW")}} ?
          <img src="@/assets/img/icons/down-arrow.svg" class="acc_img_new"/>
          </b-button>
        <b-collapse id="accordion-14" visible accordion="my-accordion-new" role="tabpanel">
                <div class="mt-2">
                <p :class="isRTL ? 'text-right' : ''">{{$t("TICKET_BOOKINGS_AUTO")}}</p>
                </div>
        </b-collapse>
        
        </div>

         <div class="col-12 mb-3">
          <b-button block v-b-toggle.accordion-15 variant="info"
          class="d-flex text-capitalize btn_acc_new justify-content-between align-items-center">
          {{$t("IS_THERE_A_TELEPHONE_NUMBER")}} ?
          <img src="@/assets/img/icons/down-arrow.svg" class="acc_img_new"/>
          </b-button>
        <b-collapse id="accordion-15" visible accordion="my-accordion-new" role="tabpanel">
                <div class="mt-2">
                <p :class="isRTL ? 'text-right' : ''">{{$t("APART_FROM_ONLINE")}}</p>
                <p class="mt-3" style="color:red" :class="isRTL ? 'text-right' : ''">
                {{$t("PLEASE_NOTE")}}</p>
                </div>
        </b-collapse>
        
        </div>


      <div class="col-12 mb-3">
          <b-button block v-b-toggle.accordion-16 variant="info"
          class="d-flex text-capitalize btn_acc_new justify-content-between align-items-center">
          {{$t("I_BOOKED_MY_TICKET")}} ?
          <img src="@/assets/img/icons/down-arrow.svg" class="acc_img_new"/>
          </b-button>
        <b-collapse id="accordion-16" visible accordion="my-accordion-new" role="tabpanel">
                <div class="mt-2">
                <p :class="isRTL ? 'text-right' : ''">{{$t("IF_YOU_HAVENT")}} 
                    <a href="mailto:hello@cineco.com" style="color:#337ab7;">hello@cineco.com</a> {{$t("FOR_ANY")}}</p>
                
                </div>
        </b-collapse>
        
        </div>

 <div class="col-12 mb-3">
          <b-button block v-b-toggle.accordion-17 variant="info"
          class="d-flex text-capitalize btn_acc_new justify-content-between align-items-center">
          {{$t("WHAT_THEATRES_DOES")}} ?
          <img src="@/assets/img/icons/down-arrow.svg" class="acc_img_new"/>
          </b-button>
        <b-collapse id="accordion-17" visible accordion="my-accordion-new" role="tabpanel">
                <div class="mt-2">
                <p :class="isRTL ? 'text-right' : ''">
                {{$t("OFFICIAL_TICKETING")}}</p>
                </div>
        </b-collapse>
        
        </div>

      </b-collapse>



      <div header-tag="header" class="p-1" role="tab">
        <b-button block v-b-toggle.accordion-3 variant="info" class="d-flex text-capitalize btn_acc justify-content-between align-items-center mb-2">
        {{$t("MOVIES_STATIC")}}<img src="@/assets/img/icons/chevron-left.svg" class="acc_img"/> </b-button>
      
      </div>
      <b-collapse id="accordion-3" visible accordion="my-accordion" role="tabpanel" class="mt-3">

           <div class="col-12 mb-3">
          <b-button block v-b-toggle.accordion-18 variant="info"
          class="d-flex text-capitalize btn_acc_new justify-content-between align-items-center">
          {{$t("TICKETS_ON_WANASA")}} ?
          <img src="@/assets/img/icons/down-arrow.svg" class="acc_img_new"/>
          </b-button>
        <b-collapse id="accordion-18" visible accordion="my-accordion-new" role="tabpanel">
                <div class="mt-2">
                <p :class="isRTL ? 'text-right' : ''">{{$t("YOU_CAN_BOOK")}}</p>
                </div>
        </b-collapse>
        </div>

                <div class="col-12 mb-3">
          <b-button block v-b-toggle.accordion-19 variant="info"
          class="d-flex text-capitalize btn_acc_new justify-content-between align-items-center">
          {{$t("HOW_MANY")}} ?
          <img src="@/assets/img/icons/down-arrow.svg" class="acc_img_new"/>
          </b-button>
        <b-collapse id="accordion-19" visible accordion="my-accordion-new" role="tabpanel">
                <div class="mt-2">
                <p :class="isRTL ? 'text-right' : ''">{{$t("USER_ARE_ALLOWED")}} <a href="mailto:hello@cineco.com" style="color:#337ab7;">
                    hello@cineco.com</a>.
                    </p>
                </div>
        </b-collapse>
        </div>


         <div class="col-12 mb-3">
          <b-button block v-b-toggle.accordion-20 variant="info"
          class="d-flex text-capitalize btn_acc_new justify-content-between align-items-center">
          {{$t("MIN_AGE")}} ?
          <img src="@/assets/img/icons/down-arrow.svg" class="acc_img_new"/>
          </b-button>
        <b-collapse id="accordion-20" visible accordion="my-accordion-new" role="tabpanel">
                <div class="mt-2">
                <p :class="isRTL ? 'text-right' : ''">{{$t("FOR_MOVIE")}}</p>
                </div>
        </b-collapse>
        </div>


                <div class="col-12 mb-3">
          <b-button block v-b-toggle.accordion-21 variant="info" 
          class="d-flex text-capitalize btn_acc_new justify-content-between align-items-center">
          {{$t("WHAT_THEATRES")}} ?
          <img src="@/assets/img/icons/down-arrow.svg" class="acc_img_new"/>
          </b-button>
        <b-collapse id="accordion-21" visible accordion="my-accordion-new" role="tabpanel">
                <div class="mt-2">
                <p :class="isRTL ? 'text-right' : ''">{{$t("TICKETING_PARTNER")}}</p>
                </div>
        </b-collapse>
        </div>

            <div class="col-12 mb-3">
          <b-button block v-b-toggle.accordion-22 variant="info"
          class="d-flex text-capitalize btn_acc_new justify-content-between align-items-center">
          {{$t("SHOWTIME")}} ?
          <img src="@/assets/img/icons/down-arrow.svg" class="acc_img_new"/>
          </b-button>
        <b-collapse id="accordion-22" visible accordion="my-accordion-new" role="tabpanel">
        <div class="mt-2">
          <p :class="isRTL ? 'text-right' : ''">{{$t("FIND_SHOWTIME")}}</p>
          </div>
        </b-collapse>
        </div>


      </b-collapse>


      <div header-tag="header" class="p-1 d-none" role="tab">
        <b-button block v-b-toggle.accordion-4 variant="info" class="d-flex text-capitalize btn_acc justify-content-between align-items-center mb-2">
            {{$t("EVENTS")}} <img src="@/assets/img/icons/chevron-left.svg" class="acc_img"/> </b-button>
     
      </div>
      <b-collapse id="accordion-4" visible accordion="my-accordion" role="tabpanel" class="mt-3 d-none">

         <div class="col-12 mb-3">
          <b-button block v-b-toggle.accordion-23 variant="info"
          class="d-flex text-capitalize btn_acc_new justify-content-between align-items-center">
          {{$t("CAN_I")}} ?
          <img src="@/assets/img/icons/down-arrow.svg" class="acc_img_new"/>
          </b-button>
        <b-collapse id="accordion-23" visible accordion="my-accordion-new" role="tabpanel">
                <div class="mt-2">
                <p :class="isRTL ? 'text-right' : ''">{{$t("YES_USER")}}</p>
                </div>
        </b-collapse>
        </div>


         <div class="col-12 mb-3">
          <b-button block v-b-toggle.accordion-24 variant="info" 
          class="d-flex text-capitalize btn_acc_new justify-content-between align-items-center">
          {{$t("CAN_I_BOOK")}} ?
          <img src="@/assets/img/icons/down-arrow.svg" class="acc_img_new"/>
          </b-button>
        <b-collapse id="accordion-24" visible accordion="my-accordion-new" role="tabpanel">
                <div class="mt-2">
                <p :class="isRTL ? 'text-right' : ''">{{$t("USER_ARE_ALLOWED_A")}} <a href="mailto:hello@cineco.com" style="color:#337ab7;">
                    hello@cineco.com</a>.
                    </p>
                </div>
        </b-collapse>
        </div>


         <div class="col-12 mb-3">
          <b-button block v-b-toggle.accordion-25 variant="info" 
          class="d-flex text-capitalize btn_acc_new justify-content-between align-items-center">
          {{$t("IS_THERE")}} ?
          <img src="@/assets/img/icons/down-arrow.svg" class="acc_img_new"/>
          </b-button>
        <b-collapse id="accordion-25" visible accordion="my-accordion-new" role="tabpanel">
                <div class="mt-2">
                <p :class="isRTL ? 'text-right' : ''">
                        {{$t("THE_CUT_OFF")}}
                </p>
                </div>
        </b-collapse>
        </div>


         <div class="col-12 mb-3">
          <b-button block v-b-toggle.accordion-26 variant="info" 
          class="d-flex text-capitalize btn_acc_new justify-content-between align-items-center">
               {{$t("WHAT_IS_MIN_AGE")}} ?
                <img src="@/assets/img/icons/down-arrow.svg" class="acc_img_new"/>
        </b-button>
        <b-collapse id="accordion-26" visible accordion="my-accordion-new" role="tabpanel">
                <div class="mt-2">
                <p :class="isRTL ? 'text-right' : ''">
                        {{$t("AGE_FOR_CHILD")}}
                </p>
                </div>
        </b-collapse>
        </div>


         <div class="col-12 mb-3">
          <b-button block v-b-toggle.accordion-27 variant="info" 
          class="d-flex text-capitalize btn_acc_new justify-content-between align-items-center">
          {{$t("HOW_DO_I_ATTEND")}} ?
          <img src="@/assets/img/icons/down-arrow.svg" class="acc_img_new"/>
          </b-button>
        <b-collapse id="accordion-27" visible accordion="my-accordion-new" role="tabpanel">
                <div class="mt-2">
                <p :class="isRTL ? 'text-right' : ''">
                        {{$t("YOU_CAN_VISIT")}}
                </p>
                </div>
        </b-collapse>
        </div>

      </b-collapse>



      <div header-tag="header" class="p-1" role="tab">
        <b-button block v-b-toggle.accordion-5 variant="info" class="d-flex text-capitalize btn_acc justify-content-between align-items-center mb-2">
           {{$t("AFTER_BOOKING")}} 
            <img src="@/assets/img/icons/chevron-left.svg" class="acc_img"/>
            </b-button>
           
      </div>
      <b-collapse id="accordion-5" visible accordion="my-accordion" role="tabpanel" class="mt-3">

       <div class="col-12 mb-3">
          <b-button block v-b-toggle.accordion-28 variant="info" 
          class="d-flex text-capitalize btn_acc_new justify-content-between align-items-center">
          {{$t("I_BOOKED")}} ?
          <img src="@/assets/img/icons/down-arrow.svg" class="acc_img_new"/>
          </b-button>
        <b-collapse id="accordion-28" visible accordion="my-accordion-new" role="tabpanel">
                <div class="mt-2">
                <p :class="isRTL ? 'text-right' : ''">
                {{$t("NO_TICKET")}}</p>
                </div>
        </b-collapse>
        </div>

           <div class="col-12 mb-3">
          <b-button block v-b-toggle.accordion-29 variant="info" 
          class="d-flex text-capitalize btn_acc_new justify-content-between align-items-center">
         {{$t("CAN_I_CHANGE")}} ?
          <img src="@/assets/img/icons/down-arrow.svg" class="acc_img_new"/>
          </b-button>
        <b-collapse id="accordion-29" visible accordion="my-accordion-new" role="tabpanel">
                <div class="mt-2">
                <p :class="isRTL ? 'text-right' : ''">{{$t("NO_YOU_CANNOT")}}</p>
                </div>
        </b-collapse>
        </div>

             <div class="col-12 mb-3">
          <b-button block v-b-toggle.accordion-30 variant="info" 
          class="d-flex text-capitalize btn_acc_new justify-content-between align-items-center">
          {{$t("CHANGE_SHOW")}} ?
          <img src="@/assets/img/icons/down-arrow.svg" class="acc_img_new"/>
          </b-button>
        <b-collapse id="accordion-30" visible accordion="my-accordion-new" role="tabpanel">
                <div class="mt-2">
                <p :class="isRTL ? 'text-right' : ''">{{$t("ONCE_YOU")}}</p>
                </div>
        </b-collapse>
        </div>

           <div class="col-12 mb-3">
          <b-button block v-b-toggle.accordion-31 variant="info" 
          class="d-flex text-capitalize btn_acc_new justify-content-between align-items-center">
          {{$t("CAN_I_CANCEL")}} ?
          <img src="@/assets/img/icons/down-arrow.svg" class="acc_img_new"/>
          </b-button>
        <b-collapse id="accordion-31" visible accordion="my-accordion-new" role="tabpanel">
                <div class="mt-2">
                <p :class="isRTL ? 'text-right' : ''">{{$t("AS_PER_WANASA")}}</p>
                </div>
        </b-collapse>
        </div>

        <div class="col-12 mb-3">
          <b-button block v-b-toggle.accordion-32 variant="info" 
          class="d-flex text-capitalize btn_acc_new justify-content-between align-items-center">
          {{$t("DO_I_NEED")}} ?
          <img src="@/assets/img/icons/down-arrow.svg" class="acc_img_new"/>
          </b-button>
        <b-collapse id="accordion-32" visible accordion="my-accordion-new" role="tabpanel">
                <div class="mt-2">
                <p :class="isRTL ? 'text-right' : ''">
                {{$t("CUSTOMER_DO_NOT")}}</p>
                </div>
        </b-collapse>
        </div>

      </b-collapse>



      <div header-tag="header" class="p-1" role="tab" >
        <b-button block v-b-toggle.accordion-6 variant="info" 
        class="d-flex text-capitalize btn_acc justify-content-between align-items-center mb-2">
        {{$t("PAYMENTS")}}
        <img src="@/assets/img/icons/chevron-left.svg" class="acc_img"/>
        </b-button>
      </div>
      <b-collapse id="accordion-6" visible accordion="my-accordion" role="tabpanel" class="mt-3">


         <div class="col-12 mb-3">
          <b-button block v-b-toggle.accordion-33 variant="info" 
          class="d-flex text-capitalize btn_acc_new justify-content-between align-items-center">
          {{$t("PAYMENTS_OPTION")}} ?
          <img src="@/assets/img/icons/down-arrow.svg" class="acc_img_new"/>
          </b-button>
        <b-collapse id="accordion-33" visible accordion="my-accordion-new" role="tabpanel">
                <div class="mt-2">
                <p :class="isRTL ? 'text-right' : ''">
                {{$t("THREE_PAYMETNS")}}</p>
                <ul>
                    <li :class="isRTL ? 'text-right' : ''">{{$t("DEBIT/CREDIT")}}</li>
                    <li :class="isRTL ? 'text-right' : ''">{{$t("PURCHASE_VOUCHER")}}</li>
                    <li :class="isRTL ? 'text-right' : ''">{{$t("PAY_DIRECTLY")}}</li>
                </ul>
                
                </div>
        </b-collapse>
        </div>



         <div class="col-12 mb-3">
          <b-button block v-b-toggle.accordion-34 variant="info" 
          class="d-flex text-capitalize btn_acc_new justify-content-between align-items-center">
                {{$t("MY_PAYMENT")}} ?
          <img src="@/assets/img/icons/down-arrow.svg" class="acc_img_new"/>
          </b-button>
        <b-collapse id="accordion-34" visible accordion="my-accordion-new" role="tabpanel">
                <div class="mt-2">
                <p :class="isRTL ? 'text-right' : ''">
                {{$t("RARE_SITUATION")}}
                    </p>
            </div>
        </b-collapse>
        </div>

          <div class="col-12 mb-3">
          <b-button block v-b-toggle.accordion-35 variant="info" 
          class="d-flex text-capitalize btn_acc_new justify-content-between align-items-center">
          {{$t("REFUND_STILL")}}
          <img src="@/assets/img/icons/down-arrow.svg" class="acc_img_new"/>
          </b-button>
        <b-collapse id="accordion-35" visible accordion="my-accordion-new" role="tabpanel">
                <div class="mt-2">
                <p :class="isRTL ? 'text-right' : ''">
                {{$t("REVERSE_REQUEST")}}
                    </p>
            </div>
        </b-collapse>
        </div>


      </b-collapse>



      <div header-tag="header" class="p-1 " role="tab">
        <b-button block v-b-toggle.accordion-7 variant="info" 
        class="d-flex text-capitalize btn_acc justify-content-between align-items-center mb-2">
        {{$t("VOUCHERS")}}
       <img src="@/assets/img/icons/chevron-left.svg" class="acc_img"/>
       </b-button>
      </div>
      <b-collapse id="accordion-7" visible accordion="my-accordion" role="tabpanel" class="mt-3">
        
        
           <div class="col-12 mb-3">
          <b-button block v-b-toggle.accordion-36 variant="info" 
          class="d-flex text-capitalize btn_acc_new justify-content-between align-items-center">
          {{$t("PAY_FOR")}} ?
          <img src="@/assets/img/icons/down-arrow.svg" class="acc_img_new"/>
          </b-button>
        <b-collapse id="accordion-36" visible accordion="my-accordion-new" role="tabpanel">
                <div class="mt-2">
                <p :class="isRTL ? 'text-right' : ''">{{$t("DONT_HAVE_TO")}}</p>
            </div>
        </b-collapse>
        </div>

         <div class="col-12 mb-3">
          <b-button block v-b-toggle.accordion-37 variant="info" 
          class="d-flex text-capitalize btn_acc_new justify-content-between align-items-center">
          {{$t("HOW_LONG")}} ?
          <img src="@/assets/img/icons/down-arrow.svg" class="acc_img_new"/>
          </b-button>
        <b-collapse id="accordion-37" visible accordion="my-accordion-new" role="tabpanel">
                <div class="mt-2">
                <p :class="isRTL ? 'text-right' : ''">{{$t("DATE_OF_GENERATION")}}</p>
            </div>
        </b-collapse>
        </div>

           <div class="col-12 mb-3">
          <b-button block v-b-toggle.accordion-38 variant="info" 
          class="d-flex text-capitalize btn_acc_new justify-content-between align-items-center">
          {{$t("HOW_MANY_TIMES")}} ?
          <img src="@/assets/img/icons/down-arrow.svg" class="acc_img_new"/>
          </b-button>
        <b-collapse id="accordion-38" visible accordion="my-accordion-new" role="tabpanel">
                <div class="mt-2">
                <p :class="isRTL ? 'text-right' : ''">{{$t("BASED_ON_COUPONS")}}</p>
            </div>
        </b-collapse>
        </div>


      </b-collapse>



      <div header-tag="header" class="p-1" role="tab">
        <b-button block v-b-toggle.accordion-8 variant="info" class="d-flex text-capitalize btn_acc justify-content-between align-items-center mb-2">
                {{$t("TROBLESHOOTING")}}
       <img src="@/assets/img/icons/chevron-left.svg" class="acc_img"/>
       </b-button>
      </div>
      <b-collapse id="accordion-8" visible accordion="my-accordion" role="tabpanel" class="mt-3">


          <div class="col-12 mb-3">
          <b-button block v-b-toggle.accordion-39 variant="info" class="d-flex text-capitalize btn_acc_new justify-content-between align-items-center">
              {{$t("ADVANCE_BOOKING")}} ?
              <img src="@/assets/img/icons/down-arrow.svg" class="acc_img_new"/>
              </b-button>
        <b-collapse id="accordion-39" visible accordion="my-accordion-new" role="tabpanel">
                <div class="mt-2">
                <p :class="isRTL ? 'text-right' : ''">{{$t("FACILITY_IS")}}</p>
                </div>
        </b-collapse>
        </div>

        <div class="col-12 mb-3">
          <b-button block v-b-toggle.accordion-40 variant="info" 
         class="d-flex text-capitalize btn_acc_new justify-content-between align-items-center">{{$t("BOOKING_NOT_COMPLETED")}} ?
          <img src="@/assets/img/icons/down-arrow.svg" class="acc_img_new"/>
          </b-button>
        <b-collapse id="accordion-40" visible accordion="my-accordion-new" role="tabpanel">
                <div class="mt-2">
                <p :class="isRTL ? 'text-right' : ''">{{$t("TIMED_OUT")}}</p>
            </div>
        </b-collapse>
        </div>

      </b-collapse>

   

  </div>


<!--Ends-->
       </section>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {

    data(){
        return{
        imageRotate:false,
        is_mobile_app: 1,
     };
    },
    watch: {
    "$route.query": {
      handler(newVal, oldVal) {
        console.log({ newVal: { ...newVal }, oldVal: { ...oldVal } });
        const is_mobile_app = parseInt(newVal.is_mobile_app) || 0;

        this.$nextTick(() => {
          if (!!is_mobile_app) {
            this.is_mobile_app = is_mobile_app;
          }
        });
      },
      immediate: true,
    },
  },
    computed:{
     ...mapGetters(['isRTL']),
    }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/faq.vue